import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { crmApi } from "@/lib/crm";
import { CheckCircle2, Circle, Trash2 } from "lucide-react";
import { format } from "date-fns";

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("open");

  const load = async () => {
    const params = filter === "open" ? { completed: false } : filter === "done" ? { completed: true } : {};
    const t = await crmApi.listTasks(params);
    setTasks(t);
  };

  useEffect(() => { load(); }, [filter]);

  const toggle = async (t) => {
    await crmApi.updateTask(t.id, { completed: !t.completed });
    load();
  };
  const remove = async (t) => {
    await crmApi.deleteTask(t.id);
    load();
  };

  return (
    <div className="p-6 md:p-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] tracking-overline uppercase text-neutral-500">To do</div>
          <h1 className="mt-2 font-serif text-4xl md:text-5xl">Tasks</h1>
        </div>
        <div className="flex gap-1">
          {["open", "done", "all"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`tasks-filter-${f}`}
              className={`px-4 py-2 text-[11px] tracking-overline uppercase border ${filter === f ? "bg-neutral-900 text-white dark:bg-white dark:text-black border-neutral-900 dark:border-white" : "border-neutral-200 dark:border-neutral-800 hover:bg-neutral-100 dark:hover:bg-neutral-900"}`}>{f}</button>
          ))}
        </div>
      </div>

      <div className="border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-950">
        {tasks.length === 0 ? (
          <div className="p-10 text-center text-sm text-neutral-500">No tasks in this view.</div>
        ) : (
          <ul className="divide-y divide-neutral-200 dark:divide-neutral-800">
            {tasks.map((t) => (
              <li key={t.id} className="flex items-center gap-3 px-5 py-4" data-testid={`tasks-row-${t.id}`}>
                <button onClick={() => toggle(t)}>
                  {t.completed ? <CheckCircle2 size={18} className="text-emerald-600" /> : <Circle size={18} className="text-neutral-400" />}
                </button>
                <div className="flex-1 min-w-0">
                  <Link to={`/crm/leads/${t.lead_id}`} className={`text-sm font-medium ${t.completed ? "line-through text-neutral-400" : ""} hover:underline`}>
                    {t.title}
                  </Link>
                  <div className="text-xs text-neutral-500">
                    {t.lead_name || "—"}{t.due_date ? ` · Due ${format(new Date(t.due_date), "d MMM yyyy")}` : ""}
                  </div>
                </div>
                <button onClick={() => remove(t)} className="text-neutral-400 hover:text-rose-500"><Trash2 size={16}/></button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
